module.exports = __webpack_public_path__ + "static/60-57ee1c1c13e2d502440e7f1d7891e387.png";